import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import UserService from '../shared/user-service';
import InVanpool from './InVanpool';
import NotInVanpool from './NotInVanpool';
import CommuteUserContactDetails from './CommuteUserContactDetails';
import Callable from '../shared/Callable';
import analyticsService from '../shared/analytics/analytics-service';

export default function() {
  const profile = UserService.getUserProfile();
  const [haveVanpoolId, updateHaveVanpoolId] = useState(null);
  const [notInVanpool, updateShowNotInVanpool] = useState(null);
  const [inVanpool, updateShowInVanpool] = useState(null);
  const [showContactDetails, updateShowContactDetails] = useState(null);
  const [forceLinking, updateForceLinking] = useState(false);
  const [showReferral, updateShowReferral] = useState(false);

  const handleOptionClick = (option) => {
    updateHaveVanpoolId(option);
    if (option == true) {
      analyticsService.analyticsProcessEvent({
        "event": "click_generic",
        "context": {
          "event_action": "vanpool id:yes"
        },
        "page": {
          "page_name": "registration"
      },
      });
    } else {
      analyticsService.analyticsProcessEvent({
        "event": "click_generic",
        "context": {
          "event_action": "vanpool id:no"
        },
        "page": {
          "page_name": "registration"
      },
      });
    }
  };

  function handleOptionKeyDown(e, option) {
    if (e.key === 'Enter' || e.key === ' ') {
        updateHaveVanpoolId(option);
    }
  }

  useEffect(() => {
    if( profile.linkVanpool && !profile.isFederatedLogin && !profile.registrationComplete){
        updateShowInVanpool(true);
        updateHaveVanpoolId(true);
        updateForceLinking(true);
        updateShowNotInVanpool(false);
        updateShowContactDetails(false);
    }
  },[]);

  useEffect(() => {
    if(haveVanpoolId === true && profile.isFederatedLogin){
        updateShowInVanpool(false);
        updateShowNotInVanpool(false);
        updateShowContactDetails(true);
    }else if(haveVanpoolId === true){
        updateShowInVanpool(true);
        updateShowNotInVanpool(false);
        updateShowContactDetails(false);
    }else if(haveVanpoolId === false){
        updateShowNotInVanpool(true);
        updateShowInVanpool(false);
        updateShowContactDetails(false);
    }else {
        updateShowNotInVanpool(false);
        updateShowInVanpool(false); 
        updateShowContactDetails(false);
    }
  }, [haveVanpoolId]);

  // clicking back from invanpool page
  function backFromInVanpool() {
            if(profile.isFederatedLogin){
                updateShowNotInVanpool(false);
                updateShowInVanpool(false); 
                updateShowContactDetails(true);
            }else{
                updateShowNotInVanpool(false);
                updateShowInVanpool(false); 
                updateShowContactDetails(false);
                updateHaveVanpoolId(null);
            }
  }

    // clicking back from not inVanpool page
    function backfromNotInVanpool() {
        updateShowNotInVanpool(false);
        updateShowInVanpool(false); 
        updateShowContactDetails(false);
        updateHaveVanpoolId(null);
      }

  // if federated login then clicking back from contact details page
  function backFromContactDetails() {
        updateShowNotInVanpool(false);
        updateShowInVanpool(false); 
        updateShowContactDetails(false);
        updateHaveVanpoolId(null);
  }

  // if federated login then clicking Next from contact details page
  function nextFromContactDetails() {
    updateShowInVanpool(true);
    updateShowNotInVanpool(false);
    updateShowContactDetails(false);
  }


  return (
    <div className='container'>
      {
        !showReferral && (
        <div className='content'>
        <div className='header'>Ok, let's build your Commute Profile</div>
        <div className='para1'>If you were invited to a vanpool, check your email invite for your Vanpool ID and Coordinator’s name.</div>
        <div className='para2'>If you’re already part of a vanpool but you don’t know your Vanpool ID and need assistance, call <span><Callable phone="800 VAN 4 WORK" analyticsEvent={true} defaultAnalytics={false}/></span></div>
        <div className='vanpool-question' role="radiogroup" aria-labelledby='vanpool-question-label'>
              <label id='vanpool-question-label'>Do you have a Vanpool ID?</label>
              <div className='radio-section'>
                <div
                  tabIndex={0}
                  role='radio'
                  aria-checked={haveVanpoolId === true}
                  onClick={() => handleOptionClick(true)}
                  onKeyDown={(e) => handleOptionKeyDown(e, true)}
                  className={haveVanpoolId === true ? 'radio active' : 'radio'}
                  aria-labelledby='Yes'
                >
                  <div className='round'></div>
                  <label id="Yes" className='text'>Yes</label>
                </div>
                <div
                  tabIndex={0}
                  role='radio'
                  aria-checked={haveVanpoolId === false}
                  onClick={() => forceLinking ? undefined : handleOptionClick(false)}
                  onKeyDown={(e) => handleOptionKeyDown(e, false)}
                  className={haveVanpoolId === false ? 'radio active' : 'radio'}
                  aria-labelledby='No'
                  aria-disabled={forceLinking}
                  style={{
                    opacity: forceLinking ? 0.5 : 1,
                    pointerEvents: forceLinking ? 'none' : 'auto',
                    cursor: forceLinking ? 'not-allowed' : 'pointer',
                  }}
                >
                  <div className='round'></div>
                  <label id="No" className='text'>No</label>
                </div>
              </div>
        </div>
      </div>
        )
      }


        {
           !haveVanpoolId && notInVanpool && <NotInVanpool backfromNotInVanpool={backfromNotInVanpool} showReferral={(val) => updateShowReferral(val)} />
        }

        {
           haveVanpoolId && inVanpool && <InVanpool backFromInVanpool={backFromInVanpool} forceLinking={forceLinking} />
        }

        {
           haveVanpoolId && showContactDetails && <CommuteUserContactDetails  backFromContactDetails={backFromContactDetails} nextFromContactDetails={nextFromContactDetails}  />
        }
    </div>

  );
}
